import LogoImage from "../../assets/logo.svg";

export default function Logo() {
  return <img src={LogoImage} alt="logo" width={67} />;
}
